import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {RateTypeModel} from '../../../models/RateTypeModel';
import {RateTypeAnagrafService} from '../../general-services/service-rate-type/rate-type-anagraf.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-rate-type-anagraf',
  templateUrl: './rate-type-anagraf.component.html',
  styleUrls: ['./rate-type-anagraf.component.scss']
})
export class RateTypeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: RateTypeModel;
  filterAllInSettings: AllSettingsFilterModel;

  displayedColumns: Array<string>;
  dataSource: any;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  initAfterOnChange: boolean;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() idSelected?: number;
  @Input() multipleSelection?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() providerForFilterInSetting?: ProviderModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;

  @Input() localCustomerListForFilterInSettings?: Array<LocalCustomerModel>;
  @Input() regionListForFilterInSettings?: Array<RegionModel>;
  @Input() contractTypeListForFilterInSettings?: Array<ContractTypeModel>;

  @Input() rateTypeAnagrafSelectedList?: Array<RateTypeModel>;

  @Input() numAnnoMeseFromForFilterInSettings?: number;
  @Input() numAnnoMeseToForFilterInSettings?: number;

  @Output() elementSelected = new EventEmitter();

  constructor(private rateTypeAnagrafService: RateTypeAnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.showActions = true;
    this.multipleSelection = false;
    this.filter = new RateTypeModel();
    this.offset = new Offset();
    this.initAfterOnChange = false;
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes
      || 'localCustomerForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'contractTypeForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes
      || 'regionListForFilterInSettings' in changes
      || 'contractTypeListForFilterInSettings' in changes
      || 'localCustomerListForFilterInSettings' in changes) {
      this.initAfterOnChange = true;
      this.getAll(this.offset);
    }
  }

  ngOnInit() {
    if (this.showActions === true) {
      this.displayedColumns = ['rateTypeCod', 'rateTypeDesc', 'actions'];
    } else {
      if (this.multipleSelection) {
        this.displayedColumns = ['isSelected', 'rateTypeCod', 'rateTypeDesc'];
      } else {
        this.displayedColumns = ['rateTypeCod', 'rateTypeDesc'];
      }
    }

    this.pageSize = +this.PAGINATOR.PAGE_SIZE_ARRAY[0];


    this.setOffsetInSession();
    if (!this.initAfterOnChange) {
      this.getAll(this.offset);
    }
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inAllSettings) {
      this.filterAllInSettings = new AllSettingsFilterModel(this.regionForFilterInSettings,
        this.localCustomerForFilterInSettings,
        this.resourceUnitForFilterInSettings, this.providerForFilterInSetting,
        this.contractTypeForFilterInSettings);

      this.filterAllInSettings.localCustomerList = this.localCustomerListForFilterInSettings;
      this.filterAllInSettings.regionList = this.regionListForFilterInSettings;
      this.filterAllInSettings.contractTypeList = this.contractTypeListForFilterInSettings;

      this.getPageSubscribe = this.rateTypeAnagrafService.getPage(offset, this.filterAllInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.setChecked();
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.rateTypeAnagrafService.getPage(offset,this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }

  resetTable() {
    this.filter = new RateTypeModel();
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }
  openDialog(id: number) {
    const rateTypeAnagrafData = this.dataSource.find(data => data.id === id) as RateTypeModel;
    const list: GenericArray[] = [
      { id: 'Rate Type Anagraf Cod', value: rateTypeAnagrafData.code.toString() },
      { id: 'Rate Type Anagraf  Description', value: rateTypeAnagrafData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.rateTypeAnagrafService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Rate Type with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('Rite Type cannot be deleted', 'Alert');
            }

          }, error => {
            this.loaderService.display(false);
            toastr.error('Rate Type with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    if (!this.multipleSelection) {
      this.elementSelected.emit({ row });
    }
  }

  selectMultipleRow(row: any) {
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('rateTypeOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('rateTypeOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      this.pageSize = this.offset.pageSize;
    }
  }


  setChecked() {
    if (this.rateTypeAnagrafSelectedList && this.rateTypeAnagrafSelectedList.length > 0) {
      for (let _i = 0; _i < this.dataSource.length; _i++) {
        const rateTypeAnagraf: RateTypeModel = this.dataSource[_i];
        for (let _j = 0; _j < this.rateTypeAnagrafSelectedList.length; _j++) {
          if (rateTypeAnagraf.id ===  this.rateTypeAnagrafSelectedList[_j].id) {
            rateTypeAnagraf.checked = true;
          }
        }
      }
    }
  }
}
